import { NgClass } from '@angular/common';
import { Component, Input, OnInit, ViewEncapsulation, OnChanges, SimpleChanges } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

@Component({
    selector: 'tc-check-pattern-password',
    imports: [
        NgClass,
        TranslateModule
    ],
    templateUrl: './check-pattern-password.component.html',
    styleUrls: ['./check-pattern-password.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class CheckPatternPasswordComponent implements OnInit, OnChanges {
  @Input() value: any;
  hasNumber = false;
  countChar = false;
  hasCapitalCase = false;
  showListValidate = false;

  constructor() {
  }
  ngOnChanges(): void {
    if (this.value) {
      this.checkPattern(this.value);
    }
  }

  ngOnInit(): void {
  }

  checkPattern(event: any): void {
    // console.log('value:', event);
    const value = event.target.value;
    // check length
    if (value.length <= 32 && value.length >= 8) {
      this.countChar = true;
    } else {
      this.countChar = false;
    }
    // check number
    if (value.match(/\d+/)) {
      this.hasNumber = true;
    } else {
      this.hasNumber = false
    }
    // check hasCapitalCase
    if (value.match(/[A-Z]/)) {
      this.hasCapitalCase = true;
    } else {
      this.hasCapitalCase = false;
    }
  }

}
